export default __webpack_public_path__ + "static/media/PaymentDone.abb671fd.png";